import React from "react";

const RenderAnswer = (answer) => {
  const parts = answer.split(/(\[image:[^\]]+\])/g);
  return parts.map((part, idx) => {
    const match = part.match(/^\[image:(.+)\]$/);
    if (match) {
      return (
        <img
          key={idx}
          src={match[1]}
          alt="Screenshot"
          style={{ maxWidth: "100%", maxHeight: 200, display: "block", margin: "8px 0" }}
        />
      );
    }
    return <span key={idx}>{part}</span>;
  });
};

export default RenderAnswer;